<template>
  <div class="hello">
    <el-row>
      <el-col style="padding: 0 10px; box-sizing: border-box" :span="12">
        <div class="tablePlu">
          <p style="margin-bottom: 10px">{{$t('VehicleManagement.carList')}}</p>
          <el-input
            @keyup.enter.native="getCarNew"
            size="small"
            v-model="searchValue"
            :placeholder="$t('common.searchTip')"
          ></el-input>
          <el-table
            v-loading="loading"
            stripe
            ref="multipleTable"
            :row-key="getRowKeys"
            @selection-change="leftChange"
            height="300"
            border
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column
              :reserve-selection="reserve"
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              :label="$t('common.id')"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="carId"
              :label="$t('common.carId')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="manufactureNum"
              :label="$t('common.manufactureNum')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="terminalId"
              :label="$t('common.terminalId')"
            ></el-table-column>
          </el-table>
        </div>
        <iPagination
          ref="page"
          :isize="small"
          @PageFun="changeSize"
        ></iPagination>
        <el-button @click="pitchUp" size="small" type="primary">{{$t('common.btn.confirm')}}</el-button>
      </el-col>
      <el-col style="padding: 0 10px; box-sizing: border-box" :span="12">
        <div class="tablePlu">
          <p style="margin-bottom: 10px">{{$t('VehicleManagement.selectedCar')}}</p>
          <el-table
            ref="rightRef"
            stripe
            @selection-change="RightChange"
            height="300"
            border
            :data="checkedTable"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              :label="$t('common.id')"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="carId"
              :label="$t('common.carId')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="manufactureNum"
              :label="$t('common.manufactureNum')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="terminalId"
              :label="$t('common.terminalId')"
            ></el-table-column>
          </el-table>
        </div>
        <el-button
          style="margin-top: 10px"
          @click="deleteList"
          size="small"
          type="danger"
          >{{$t('common.btn.delete')}}</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>
<script>
import iPagination from "./pagination.vue";
import moment from "moment";
export default {
  components: {
    iPagination,
  },
  data() {
    return {
      dialogVisible: false,
      searchValue: "",
      input: "",
      reserve: true,
      loading: false,
      tableData: [],
      checkedTable: [],
      selected: [],
      rightSelect: [],
      currentPage1: 1,
      pageNum: 1,
      small: true,
      pageSize: 10,
      getRowKeys(row) {
        return row.terminalId;
      },
      valueDate: [],
    };
  },
  props: ["carItem", "id"],
  computed: {
    paramsValue() {
      return { carItem: this.carItem, id: this.id };
    },
  },
  watch: {
    paramsValue: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.getCar(val);
      },
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getCarNew() {
      this.pageSize = 10;
      this.pageNum = 1;
      this.getCar();
    },
    getCar(val) {
        console.log(val)
      this.loading = true;
      let orgId = "";
      if (val && val.id) {
        orgId = val.id;
      } else {
        orgId = sessionStorage.getItem("roleData");
      }
      let param = {
        orgId: orgId,
        number: this.searchValue,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      this.$store
        .dispatch("ElectricFence/GET_GETFENCECARMESSAGE", param)
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.list;
            this.$refs.page.CommandTotal = res.data.data.total;
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getRightCar() {
      let param = {
        fenceNum: this.carItem.fenceNum,
      };
      this.$store
        .dispatch("CloudFence/GET_GETCHOICECAR", param)
        .then((res) => {
          if (res.data.code == 200) {
            this.checkedTable = res.data.data;
            this.$nextTick(() => {
                this.checkedTable.map((item) => {
                this.$refs.rightRef.toggleRowSelection(item);
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {});
    },
    getRightTerminal() {
      let param = {
        fenceNum: this.carItem.fenceNum,
      };
      this.$store
        .dispatch("ElectricFence/GET_GETCHOICETERMINAL", param)
        .then((res) => {
          if (res.data.code == 200) {
            this.checkedTable = res.data.data;
            this.$nextTick(() => {
                this.checkedTable.map((item) => {
                this.$refs.rightRef.toggleRowSelection(item);
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {});
    },
    changeSize(item) {
      console.log(item);
      this.pageNum = item.pageNum;
      this.pageSize = item.pageSize;
      this.getCar(this.paramsValue);
    },
    deleteList() {
      this.rightSelect.map((item, t) => {
        this.checkedTable.map((items, index) => {
          if (items.terminalId == item.terminalId) {
            this.checkedTable.splice(index, 1);
            this.$refs.multipleTable.toggleRowSelection(item, false);
          }
        });
      });
      this.$emit("postParam", this.checkedTable);
    },
    RightChange(selected) {
      this.rightSelect = selected;
    },
    pitchUp() {
      if (this.checkedTable.length > 0) {
        const arr = this.selected.concat(this.checkedTable);
        const res = new Map();
        const checkList = arr.filter(
          (item) => !res.has(item.carId) && res.set(item.carId, 1)
        );
        this.checkedTable = checkList;
      } else {
        this.checkedTable = this.selected;
      }
      this.$emit("postParam", this.checkedTable);
    },
    leftChange(selected) {
      this.selected = selected;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/command.less";
.el-table__body,
.el-table__footer,
.el-table__header {
  border-collapse: collapse;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #f2f6fc !important;
  border-color: #dcdfe6 !important;
}
</style>
